// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-l_fr","catalogByServiceItem__title":"c-l_fs"};